interface IProps {
  fill?: string;
}

function IConCrownComponent({ fill = "#9C8B58" }: IProps) {
  return (
    <svg
      width="20"
      height="11"
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 9H2V11H18V9Z" fill={fill} />
      <path d="M18 6H2V7H18V6Z" fill={fill} />
      <path
        d="M10 4C11.1046 4 12 3.10457 12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2C8 3.10457 8.89543 4 10 4Z"
        fill={fill}
      />
      <path
        d="M5.5 4C6.32843 4 7 3.32843 7 2.5C7 1.67157 6.32843 1 5.5 1C4.67157 1 4 1.67157 4 2.5C4 3.32843 4.67157 4 5.5 4Z"
        fill={fill}
      />
      <path
        d="M14.5 4C15.3284 4 16 3.32843 16 2.5C16 1.67157 15.3284 1 14.5 1C13.6716 1 13 1.67157 13 2.5C13 3.32843 13.6716 4 14.5 4Z"
        fill={fill}
      />
      <path
        d="M1.5 5C2.32843 5 3 4.32843 3 3.5C3 2.67157 2.32843 2 1.5 2C0.671573 2 0 2.67157 0 3.5C0 4.32843 0.671573 5 1.5 5Z"
        fill={fill}
      />
      <path
        d="M18.5 5C19.3284 5 20 4.32843 20 3.5C20 2.67157 19.3284 2 18.5 2C17.6716 2 17 2.67157 17 3.5C17 4.32843 17.6716 5 18.5 5Z"
        fill={fill}
      />
    </svg>
  );
}

export { IConCrownComponent };
